/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  appname: "Ink Academy",
  urlbase: "https://api-inkacademy.entregadigital.app.br/api/v1/pwa/",

  ds: "&dM4_", // Descryptor Hash

  oneSignalAppID: "",
  oneSignalSafariWebID: "",
  subdomainName: "",

  disableDevToolsDetector: false,
};
